/**
 * Simple SPA Router
 * Handles client-side routing for the application
 */

export class Router {
    constructor() {
        this.routes = {};
        this.currentPath = '';
    }

    addRoute(path, handler) {
        this.routes[path] = handler;
    }

    navigate(path) {
        window.history.pushState({}, '', path);
        this.handleRoute();
    }

    handleRoute() {
        const path = window.location.pathname;
        this.currentPath = path;

        const handler = this.routes[path];
        const app = document.getElementById('app');

        if (handler) {
            handler(app);
        } else {
            // 404 - redirect to landing
            this.navigate('/');
        }

        // Dispatch custom event for route change
        document.dispatchEvent(new CustomEvent('routeChanged', { detail: { path } }));

        // Scroll to top
        window.scrollTo(0, 0);
    }

    init() {
        // Handle browser back/forward
        window.addEventListener('popstate', () => this.handleRoute());

        // Handle link clicks
        document.addEventListener('click', (e) => {
            const link = e.target.closest('a[data-link]');
            if (link) {
                e.preventDefault();
                const href = link.getAttribute('href');
                this.navigate(href);
            }
        });

        // Initial route
        this.handleRoute();
    }
}
